<template>
  <button
    type="button"
    class="btn btn-primary btn-floating btn-lg"
    id="btn-back-to-top"
    ref="mybutton"
    @click="backToTop"
  >
    <i class="fas fa-arrow-up"></i>
  </button>
  <Navbar/>
  <div class="p-4">
    <div class="d-flex mb-4 text-darker justify-content-evenly">
      <div>
        <a href="#" class="text-secondary text-decoration-none" @click="isSearchVisible = !isSearchVisible">
          <i class="fas fa-search"></i>
          <span v-show="isSearchVisible" @click="this.searchText = '';fetchUsers">Zamknij wyszukiwanie</span>
          <span v-show="!isSearchVisible">Szukaj</span>
        </a>
        <div v-show="isSearchVisible">
          <input v-model="searchText" type="search" class="form-control" placeholder="Wyszukaj w panelu" @input="fetchUsers">
        </div>
      </div>
      <RefreshButton :refreshing="refreshing"/>
    </div>
    <hr>
    <div class="row">
      <div class="d-lg-flex justify-content-between my-2">
        <h5 class="fw-bold">
          LISTA UŻYTKOWNIKÓW
        </h5>
      </div>
    </div>
    <router-link :to="{ name: 'CreateUser' }" class="btn btn-success">
      Dodaj nowego użytkownika
    </router-link>

    <router-link class="mailing-button btn btn-primary" :to="{ name: 'MailingList' }">
      Lista mailingowa
    </router-link>
  </div>
  <hr>
  <table class="table table-striped">
    <thead>
    <tr>
      <td>Lp.</td>
      <td>Nazwa użytkownika</td>
      <td>Lista przywilejów</td>
      <td>Akcje</td>
    </tr>
    </thead>
    <tbody>
    <tr v-for="(user, index) in users" :key="index">
      <td>{{ index + 1 }}</td>
      <td class="fw-bold">{{ user.name }} {{ user.lastName }} ({{ user.email }})</td>
      <td v-if="superAdmin?.email === currentUserEmail || secondAdmin?.email === currentUserEmail">
        <label class="d-block">
          <input type="checkbox" v-bind="user.permission.canCreateVehicles" v-model="user.permission.canCreateVehicles"> Dodaje pojazdy
        </label>
        <label class="d-block">
          <input type="checkbox" v-bind="user.permission.canRemoveVehicles" v-model="user.permission.canRemoveVehicles"> Usuwa pojazdy
        </label>
        <label class="d-block">
          <input type="checkbox" v-bind="user.permission.canEditVehicles" v-model="user.permission.canEditVehicles"> Edytuje pojazdy
        </label>
        <label class="d-block">
          <input type="checkbox" v-bind="user.permission.canCreateTasks" v-model="user.permission.canCreateTasks"> Dodaje zlecenia
        </label>
        <label class="d-block">
          <input type="checkbox" v-bind="user.permission.canRemoveTasks" v-model="user.permission.canRemoveTasks"> Usuwa zlecenia
        </label>
        <label class="d-block">
          <input type="checkbox" v-bind="user.permission.canEditTasks" v-model="user.permission.canEditTasks"> Edytuje zlecenia
        </label>
        <label class="d-block">
          <input type="checkbox" v-bind="user.permission.canCreateDrivers" v-model="user.permission.canCreateDrivers"> Dodaje kierowców
        </label>
        <label class="d-block">
          <input type="checkbox" v-bind="user.permission.canRemoveDrivers" v-model="user.permission.canRemoveDrivers"> Usuwa kierowców
        </label>
        <label class="d-block">
          <input type="checkbox" v-bind="user.permission.canEditDrivers" v-model="user.permission.canEditDrivers"> Edytuje kierowców
        </label>
        <label class="d-block">
          <input type="checkbox" v-bind="user.permission.canAddUsers" v-model="user.permission.canAddUsers"> Dodaje użytkowników
        </label>
        <label class="d-block">
          <input type="checkbox" v-bind="user.permission.canDeleteUsers" v-model="user.permission.canDeleteUsers"> Usuwa użytkowników
        </label>
        <label class="d-block">
          <input type="checkbox" v-bind="user.permission.canEditMapPoints" v-model="user.permission.canEditMapPoints"> Edytuje adresy na mapie
        </label>
        <label class="d-block">
          <input type="checkbox" v-bind="user.permission.canUseAutomaticLabels" v-model="user.permission.canUseAutomaticLabels"> Modyfikuje etykiety automatyczne
        </label>
        <button class="btn btn-sm btn-primary me-2" @click="updatePermission(user)">
          Zapisz
        </button>
      </td>
      <td v-else>
        <span class="text-danger">
          Tylko Administrator może zarządzać uprawnieniami
        </span>
      </td>
      <td v-if="(currentUserName === user.name && currentUserEmail === user.email) || (currentUserName === superAdmin?.name && currentUserEmail === superAdmin?.email) || (currentUserName === secondAdmin?.name && currentUserEmail === secondAdmin.email)">
        <router-link class="btn btn-sm btn-info text-white" :to="{ name: 'EditUser', params: { id: user.id } }">
          Edytuj dane
        </router-link>
        <button v-if="((currentUserName === superAdmin?.name && currentUserEmail === superAdmin?.email) || (currentUserName === secondAdmin?.name && currentUserEmail === secondAdmin?.email)) && user.email !== superAdmin?.email && user.email !== secondAdmin?.email" class="btn btn-danger btn-sm ms-1" @click="deleteUser(user)">
          Usuń użytkownika
        </button>
      </td>
      <td v-else></td>
    </tr>
    </tbody>
  </table>
</template>

<script>
import Navbar from '@/components/Navbar'
import Swal from 'sweetalert2'
import axios from 'axios'
import RefreshButton from '@/components/Layout/RefreshButton.vue'
import emitter from '@/modules/events/emitter'

export default {
  name: 'UserList',
  components: { RefreshButton, Navbar },
  data () {
    return {
      axiosConfig: { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } },
      users: [],
      superAdmin: null,
      secondAdmin: null,
      currentUserName: '',
      currentUserEmail: '',
      isSearchVisible: false,
      searchText: '',
      refreshing: false
    }
  },
  created () {
    emitter.on('refreshed', this.fetchUsers)

    this.$store.commit('setInitialCalendarLoading', true)
    window.addEventListener('scroll', this.scrollFunction)
    this.fetchUsers()
  },
  methods: {
    async fetchUsers () {
      try {
        this.refreshing = true
        const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
        this.users = (await axios.get(`${process.env.VUE_APP_API_BASE_URL}User`, config)).data

        this.superAdmin = this.users.find(user => user.email === 's.kozanecki@growingeco.pl')
        this.secondAdmin = this.users.find(user => user.email === 'd.mruk@growingeco.pl')

        this.currentUserName = localStorage.getItem('username')
        this.currentUserEmail = localStorage.getItem('email')

        if (this.searchText !== '') {
          this.users = this.users.filter(user => user.name.toLowerCase().includes(this.searchText.toLowerCase()))
        }
      } catch (e) {
        console.log(e)
      } finally {
        this.refreshing = false
      }
    },
    async updatePermission (user) {
      try {
        const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
        const putData = {
          canCreateVehicles: user.permission.canCreateVehicles,
          canEditVehicles: user.permission.canEditVehicles,
          canRemoveVehicles: user.permission.canRemoveVehicles,
          canCreateTasks: user.permission.canCreateTasks,
          canEditTasks: user.permission.canEditTasks,
          canRemoveTasks: user.permission.canRemoveTasks,
          canCreateDrivers: user.permission.canCreateDrivers,
          canEditDrivers: user.permission.canEditDrivers,
          canRemoveDrivers: user.permission.canRemoveDrivers,
          canAddUsers: user.permission.canAddUsers,
          canDeleteUsers: user.permission.canDeleteUsers,
          canEditMapPoints: user.permission.canEditMapPoints,
          canUseAutomaticLabels: user.permission.canUseAutomaticLabels
        }
        await axios.put(`${process.env.VUE_APP_API_BASE_URL}User/Permission/${user.id}`, putData, config)
        await Swal.fire('Zapisano zmiany', '', 'success')
      } catch (e) {
        console.log(e)
        await Swal.fire('Nie udało się zapisać zmian', '', 'error')
      }
    },

    async deleteUser (user) {
      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }

      const dialogResult = await Swal.fire({
        title: `Czy na pewno chcesz usunąć użytkownika: ${user.email} (${user.name} ${user.lastName})`,
        icon: 'question',
        showConfirmButton: true,
        showCancelButton : true,
        confirmButtonText: 'Tak',
        cancelButtonText : 'Nie'
      })

      if (dialogResult.isConfirmed) {
        await axios.delete(`${process.env.VUE_APP_API_BASE_URL}User/${user.id}`, config)
        await Swal.fire('Usunięto użytkownika', 'Użytkownik został usunięty z programu', 'success')
      }
    },

    scrollFunction () {
      if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        if (this.$refs.mybutton !== null) {
          this.$refs.mybutton.style.display = 'block'
        }
      } else {
        if (this.$refs.mybutton !== null) {
          this.$refs.mybutton.style.display = 'none'
        }
      }
    },
    backToTop () {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    }
  }
}
</script>

<style scoped>
#btn-back-to-top {
  position: fixed;
  bottom: 20px;
  right: 20px;
  display: none;
}
.mailing-button {
  margin-left: 15px;
}
</style>
